module.exports = __webpack_public_path__ + "img/20_120.5af6052b.png";